/* eslint-disable no-use-before-define */
/* eslint-disable camelcase */
import axios from 'axios'
import { useCookies } from 'vue3-cookies'
import { ref } from 'vue'
import { deleteToken } from './loginout'

const { cookies } = useCookies()

const instance = axios.create({
  baseURL: process.env.VUE_APP_LMS_URL,
})

let getAccess = ''
let getRefresh = ''
let headers = ''
// let getAccess = cookies.get("access_token");
// let getRefresh = cookies.get("refresh_token");
// let headers = { 'Authorization' : getAccess };

// eslint-disable-next-line consistent-return
export async function loadMypage() {
  let mypageUrl = ''
  getAccess = cookies.get('access_token')
  getRefresh = cookies.get('refresh_token')
  const accessErr = ref(false)
  // console.log(getAccess)
  // console.log(getRefresh)
  try {
    headers = { Authorization: getAccess }
    mypageUrl = await instance.get(`/api/v1/member/my/profile`, { headers })
    // console.log(mypageUrl)
    // console.log(mypageUrl.data.content);
    // const mypageRes = mypageUrl.data
    // console.log('mypageRes', mypageRes)
    // console.log('mypageRes.status_code', mypageRes.status_code)
    // return mypageRes
  } catch (err) {
    // console.log(err.response.data)
    if (err.response.data.status_code === 401) {
      accessErr.value = true
      // return err.response.data
      return err.response.data.status_code
    }
    mypageValidity(err.response.data.status_code)
  }
  const mypageRes = mypageUrl.data
  // console.log('mypageRes', mypageRes)
  // console.log('mypageRes.status_code', mypageRes.status_code)
  return mypageRes
  // getAccess가 None이면 비정상적 접근이라고 return
  // getAccess가 존재하면 값 return
}

// eslint-disable-next-line consistent-return
export async function mypageValidity(status) {
  getAccess = cookies.get('access_token')
  getRefresh = cookies.get('refresh_token')
  // const accessErr = ref(false)
  try {
    if (status === 400) {
      // console.log('400찍히는 함수에 들어옴')
      const renewData = { refresh_token: getRefresh }
      // console.log(renewData)
      const renewRes = await instance.post(
        `/api/v1/member/auth/token`,
        renewData
      )
      // console.log(renewRes)
      // console.log('AT 갱신시켰음')
      getAccess = cookies.set(
        'access_token',
        renewRes.data.content.access_token
      )
      headers = { Authorization: getAccess }
      const testStatus = await instance.get(`/api/v1/member/my/profile`, {
        headers,
      })
      console.log(testStatus)
    } else if (status === 401) {
      // console.log('401태웠음, alert 메세지 출력해야함', status)
      return status
    }
    // else if (status === 401) {
    //   accessErr.value = true
    // }
    else {
      throw new Error('토큰 진입 실패')
    }
  } catch (err) {
    console.log(err)
    if (err.response.data.code === '4040011') {
      alert('로그아웃되었습니다.')
      deleteToken()
    }
  }
}

// eslint-disable-next-line consistent-return
export async function myapgePWChk(curPW) {
  getAccess = cookies.get('access_token')
  headers = { Authorization: getAccess }
  const data = { password: curPW.value }

  // console.log(data);
  // console.log(headers);
  try {
    const chkPwRes = await instance.post(
      `/api/v1/member/my/profile/verification`,
      data,
      { headers }
    )
    // console.log(chkPwRes);
    if (chkPwRes.data.status_code === 200) {
      // console.log("검증성공")
      // return chkPwRes.data.status_code
      return chkPwRes.data
    }
  } catch (err) {
    // console.log('err')
    // console.log(err.response.data)
    return err.response.data
    // if (err.response.data.code === 'MB41003400') {
    //   // console.log("비밀번호가 일치하지 않습니다.");
    //   return err.response.data.code
    // } else if (err.response.data.code === 'MB41002400') {
    //   // console.log("비밀번호가 입력되지 않았습니다.");
    //   return err.response.data.code
    // }
  }
}

// eslint-disable-next-line consistent-return
export async function mypagePWChange(oldPW, newPW, newPWChk) {
  const datas = {
    old_pwd: oldPW.value,
    new_pwd: newPW.value,
    new_pwd_confirm: newPWChk.value,
  }
  try {
    const pwChangeRes = await instance.put(
      `/api/v1/member/my/profile/pwd`,
      datas,
      { headers }
    )
    // console.log(pwChangeRes);
    if (pwChangeRes.data.status_code === 200) {
      return pwChangeRes.data.code
    }
    // eslint-disable-next-line no-throw-literal
  } catch (err) {
    // console.log("========err=============")
    // console.log(err);
    return err.response.data.code
    // if (err.response.data.code === 'MB41104400') {
    //   // console.log("비밀번호 확인 값을 잘못 입력하셨습니다.");
    //   alert('비밀번호 확인 값을 잘못 입력하셨습니다.')
    // } else if (err.response.data.code === 'MB41103400') {
    //   // console.log("현재 비밀번호와 새 비밀번호가 일치합니다.");
    //   alert('현재 비밀번호와 새 비밀번호가 일치합니다.')
    // } else if (err.response.data.code === 'MB41105400') {
    //   // console.log("8자~20자 영문 대소문자, 숫자, 특수문자를 사용해주세요.");
    //   alert('8자~20자 영문 대소문자, 숫자, 특수문자를 사용해주세요.')
    // } else if (err.response.data.code === '4000001') {
    //   // console.log("다시 로그인해주세요.");
    //   // console.log("로그아웃처리하기");
    //   alert('다시 로그인해주세요.')
    //   alert('로그아웃처리하기')
    // }
  }
}

// eslint-disable-next-line consistent-return
export async function loadModifyMypage() {
  getAccess = cookies.get('access_token')
  if (getAccess) {
    headers = { Authorization: getAccess }
    const loadDataRes = await instance.get(`/api/v1/member/my/profile`, {
      headers,
    })
    // console.log(loadDataRes);
    try {
      const mypageData = loadDataRes.data
      // console.log("mypageData");
      // console.log(mypageData);
      return mypageData
    } catch (err) {
      // console.log(err);
    }
  } else {
    // console.log("비정상적인 접근입니다");
  }
}

// eslint-disable-next-line consistent-return
export async function sendModifyMypage(
  nickname,
  phone,
  email,
  recv_sms,
  recv_email
) {
  getAccess = cookies.get('access_token')
  try {
    headers = { Authorization: getAccess }
    const mypageDatas = {
      nickname,
      phone,
      email,
      recv_sms,
      recv_email,
    }
    const changeData = await instance.put(
      `/api/v1/member/my/profile`,
      mypageDatas,
      { headers }
    )
    // console.log(changeData);
    if (changeData.data.status_code === 200) {
      // console.log("변경성공");
      return changeData.data.status_code
    }
  } catch (err) {
    // console.log(err);
  }
}
